import type { FaireProductEntity } from "../../entity_types/product";

export const p_s42n3838h7: FaireProductEntity = {
  token: "p_s42n3838h7",
  type: "product",
  name: "The Five Minute Journal for Kids",
  brandToken: "b_19ve7j7a7y",
  brandName: "Intelligent Change",
  imageUrl:
    "https://cdn.faire.com/fastly/d38e00c3a958f51fbcfa374917570225206b7b245ef74f761fca43d9db2f9587.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9c6b0cee954628d1b2737a9336a054ca752aba975da11dc516d0878344e2eb99.jpeg",
    "https://cdn.faire.com/fastly/6cef893cc6b80da47fa5f09c701ea59b1623d39844637f4791bfb07d6cb068a5.jpeg",
    "https://cdn.faire.com/fastly/707d8bbd9e0559408b0cb1411b9dd1976aa85ecdff358d584e8beffe24938ca7.jpeg",
    "https://cdn.faire.com/fastly/7ce37d39458db25cb2a904d021faa8b9c331b9c18a448d5fdd5668cd6019fa63.jpeg",
    "https://cdn.faire.com/fastly/5943e171ff15ea4f23bd16f69447307bd4f83210038eed25165c6796d341cfae.jpeg",
    "https://cdn.faire.com/fastly/59a76787466d623882d070170b894d4984b9c5763bd5938c4d516646419fa3d6.jpeg",
    "https://cdn.faire.com/fastly/7fbc323e3e4342a5792b12f82abed32499ef7fbc0f0a3c6c3b7f1a8b556000e5.jpeg",
    "https://cdn.faire.com/fastly/ac45637c1db358f86a7430bc34a40054c2df55dfbd34cbc57c4dc68620e0ef5a.jpeg",
  ],
  priceDollars: 21,
  description:
    "Growth for the growing. A step in the right direction for little feet. Daily reflection for the early days of life. This illustrated and colorful edition of the best-selling Five Minute Journal is designed to focus young minds on the good things in their lives, fostering gratitude and preserving positive memories for years to come. Recommended for 5-12 year olds. Printed on sustainably sourced paper stock from FSC suppliers.",
  tags: [],
  msrpDollars: 42,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:50:20.602Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
